const USER_PERMISSION_DISPLAY_MAP = {
    editor: 'Editor',
    viewer: "Viewer",
}

const ACCESS_MENU_ACTIONS = [
    {
        actionText: 'Viewer',
        value: 'viewer',
    },
    {
        actionText: 'Editor (Coming Soon!)',
        value: 'editor',
        disabled: true
    },
]

const GENERAL_PERMISSION_DISPLAY_MAP = {
    restricted: 'Restricted',
    anyoneWithLink: "Anyone with link",
}

const GENERAL_ACCESS_OPTIONS = [
    {
        actionText: 'Restricted',
        value: 'restricted',
    },
    {
        actionText: 'Anyone with link',
        value: 'anyoneWithLink',
    },
]

export {
    USER_PERMISSION_DISPLAY_MAP,
    ACCESS_MENU_ACTIONS,
    GENERAL_PERMISSION_DISPLAY_MAP,
    GENERAL_ACCESS_OPTIONS
}
